/* eslint-disable no-undef */
export const ENV_REACT_APP_UNARIC_UNIFY_SYNC_APPROVE =
  process.env.REACT_APP_UNARIC_UNIFY_SYNC_APPROVE;
export const ENV_REACT_APP_UNARIC_UNIFY_CLIENT_APPROVE =
  process.env.REACT_APP_UNARIC_UNIFY_CLIENT_APPROVE;

export const ENV_SF_CLIENT_ID = process.env.REACT_APP_SF_CLIENT_ID;
export const ENV_SF_REDIRECT_URI = process.env.REACT_APP_SF_REDIRECT_URI;
